import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#ffff", // Light gray
      paper: "#f4f4f4", // Very light gray
      dark: "#121212", // Blackish, dark gray
      table: "",
      white: "#FFFFFF",
      gray: "#0000000f",
    },
    primary: {
      main: "#4788f2", // Vivid blue
    },
    secondary: {
      main: "#5F6368", // Medium gray
    },
    text: {
      primary: "#2A3467", // Dark blue-gray
      secondary: "#5F6368", // Medium gray
      placeholder: "#5C5757", // Warm gray
      dark: "#121212", // Blackish, dark gray
      black: "#000000",
      red: "#E53935", //sold red
      solidGray: "#767676", //solid gray
      lightBlue: "#4788f2", //light blue
      cardsGray: "#2A346780",
    },
  },
  typography: {
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    h1: {
      fontSize: "2.5rem",
      fontWeight: "600",
      marginBottom: "30px",
    },

    h2: {
      fontSize: "1.5rem",
      fontWeight: "600",
      color: "black",
    },
    h3: {
      fontSize: "2.3rem",
      fontWeight: "bold",
    },
    h4: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    h5: {
      color: "black",
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
    },
    body2: {
      fontSize: "0.875rem",
      color: "text.secondary",
    },
    tabLabel: {
      fontSize: "1.2rem",
      fontWeight: 500,
      textTransform: "none",
    },
  },

  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #ddd",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "1.2rem",
          fontWeight: 500,
          textTransform: "none",
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          padding: "1rem",
        },
      },
    },

    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#e8e8e8", // Light gray (global body background)
          margin: 0,
          padding: 0,
          overflowX: "hidden",
        },
      },
    },
  },
});

export default theme;
